// extracted by mini-css-extract-plugin
module.exports = {"align-items-center":"booking-statistic_align-items-center__2Oy6J","px-8":"booking-statistic_px-8__2KIAy","pt-8":"booking-statistic_pt-8__1lQQI"};